import React from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {useTranslation} from "react-i18next";
import {CancelButton} from "../../../../../components/common/ActionButtons";
import TileButton from "../../../../../components/chat/FilePicker/components/TileButton";
import {ButtonsContainer} from "./ResetPasswordRedirectDialog.styled";

interface ResetPasswordRedirectDialogProps {
    open: boolean;
    onClose: () => void;
    onAppResetClick: () => void;
    onRedirectClick: () => void;
}

const ResetPasswordRedirectDialog = ({open, onAppResetClick, onRedirectClick, onClose}: ResetPasswordRedirectDialogProps) => {
    const {t} = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth aria-labelledby="reset-password-redirect-dialog-title">
            <DialogTitle sx={{padding: '24px 32px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                {t('resetPasswordDialog.title')}

                <Tooltip title={t('common.close')}>
                    <IconButton onClick={onClose} size="small" aria-label={t('common.close') as string}>
                        <CloseIcon />
                    </IconButton>
                </Tooltip>
            </DialogTitle>

            <DialogContent>
               <ButtonsContainer>
                   <TileButton onClick={onAppResetClick}>
                       <Typography color="primary" variant="button">
                           {t('resetPasswordDialog.application')}
                       </Typography>
                   </TileButton>

                   <TileButton onClick={onRedirectClick}>
                       <Typography color="primary" variant="button">
                           {t('resetPasswordDialog.externalSystem')}
                       </Typography>
                   </TileButton>
               </ButtonsContainer>
            </DialogContent>

            <DialogActions>
                <CancelButton onClick={onClose}>
                    {t('common.cancel')}
                </CancelButton>
            </DialogActions>
        </Dialog>
    );
};

export default ResetPasswordRedirectDialog;